// removed by extract-text-webpack-plugin
module.exports = {"tagline":"_225mOkdrPfrlG3UNDGqg2h","status":"_14gJR9pfb3ahJ1GDgxOeYG","headline":"_2n80jzIiXp61oOxZuAiN7k","features":"UQ8v2WJldaHnkXBfpr5KD","api":"_1XaDHImY_kXzTriNPmPx6F","support":"_2iw90wsBkauG0L_OIXfu-b","modernjs":"_3SZ5Y_p1tb97wrtyTeaS2s","easystart":"_1kWZNYGdS7Rqv4Yb1UQjpb","footer":"_1jnIMuy5F7v3djvk_2DOD","copy":"_1aOqyF8HdLSeLV4t8Tvg2L"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/style.css
// module id = 674
// module chunks = 0